import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSolidCheckCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	title: "Circle with checkmark inside",
	width: 41,
	height: 40,
	"aria-hidden": "true",
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.5 20C0.5 8.98438 9.40625 0 20.5 0C31.5156 0 40.5 8.98438 40.5 20C40.5 31.0938 31.5156 40 20.5 40C9.40625 40 0.5 31.0938 0.5 20ZM29.4844 16.5625C30.3438 15.7031 30.3438 14.375 29.4844 13.5156C28.625 12.6562 27.2969 12.6562 26.4375 13.5156L18 21.9531L14.4844 18.5156C13.625 17.6562 12.2969 17.6562 11.4375 18.5156C10.5781 19.375 10.5781 20.7031 11.4375 21.5625L16.4375 26.5625C17.2969 27.4219 18.625 27.4219 19.4844 26.5625L29.4844 16.5625Z",
		fill: "#107F47"
	})]
});
const ForwardRef = forwardRef(SvgIconSolidCheckCircle);
export { ForwardRef as ReactComponent };
